// extracted by mini-css-extract-plugin
export default {"skeleton":"ProjectList_skeleton__e8Alj","h1":"ProjectList_h1__R4-mx","divider":"ProjectList_divider__AFXpl","search":"ProjectList_search__N+xr9","list":"ProjectList_list__DAqgK"};